import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { companyInfo, footerLinks, legalDisclaimer } from '../../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <span className="text-xl font-semibold tracking-tight text-white mb-6 block">
              G Developments
            </span>
            <p className="text-sm leading-relaxed text-stone-400 max-w-md">
              Crafting exceptional living spaces with uncompromising quality and timeless design. 
              Your trusted partner in premium real estate development across Egypt.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white tracking-wide uppercase mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href}
                    className="text-sm text-stone-400 hover:text-white transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-semibold text-white tracking-wide uppercase mb-6">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-purple-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-stone-400">{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-purple-500 flex-shrink-0" />
                <div className="flex flex-col gap-1">
                  <a 
                    href={`tel:${companyInfo.phone}`}
                    className="text-sm text-stone-400 hover:text-white transition-colors duration-300"
                  >
                    {companyInfo.phone}
                  </a>
                  {companyInfo.phone2 && (
                    <a 
                      href={`tel:${companyInfo.phone2}`}
                      className="text-sm text-stone-400 hover:text-white transition-colors duration-300"
                    >
                      {companyInfo.phone2}
                    </a>
                  )}
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-purple-500 flex-shrink-0" />
                <div className="flex flex-col gap-1">
                  <a 
                    href="mailto:sherif.asfour@thegdevelopments.com"
                    className="text-sm text-stone-400 hover:text-white transition-colors duration-300"
                  >
                    sherif.asfour@thegdevelopments.com
                  </a>
                  <a 
                    href="mailto:karim.elkomaty@thegdevelopments.com"
                    className="text-sm text-stone-400 hover:text-white transition-colors duration-300"
                  >
                    karim.elkomaty@thegdevelopments.com
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-stone-500">
              © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-xs text-stone-500 text-center md:text-right">
              {legalDisclaimer}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
